import { jsx as _jsx } from "react/jsx-runtime";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import InstagramIcon from '@mui/icons-material/Instagram';
// Icone do tipo de contato, compartilhado entre ArtPreview e AdditionalInformationStep
// para evitar switches duplicados (Sonar: duplicate blocks).
export function getContactIcon(typeId, style) {
    switch (typeId) {
        case 'whatsapp':
            return _jsx(WhatsAppIcon, { fontSize: "small", style: style });
        case 'telefone':
            return _jsx(LocalPhoneIcon, { fontSize: "small", style: style });
        case 'email':
            return _jsx(MailOutlineIcon, { fontSize: "small", style: style });
        case 'instagram':
            return _jsx(InstagramIcon, { fontSize: "small", style: style });
        default:
            return null;
    }
}
